var isDev = window.location.href.startsWith("https://local");
// alert(isDev);
const gameApiUrl = isDev ? 'https://localhost:44337' : 'https://www.onlinescorebord.nl';
export { gameApiUrl };